import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M10.333 7.338c-1.764 0-3.36.66-4.591 1.73L3.346 6.673v5.989h5.989l-2.41-2.41a5.292 5.292 0 013.408-1.25 5.33 5.33 0 015.057 3.66l1.577-.52c-.925-2.787-3.54-4.804-6.634-4.804z" fill="#54585D" fillOpacity=".6" /></svg>);